import type { MatchConfig } from '@/services/matchConfigService'
import type { GfxImageSlot, MatchData } from '@/types'

export const getMajorAsset = (matchConfig: MatchConfig | MatchData | null, slotID: number): string | null => {
  if (!matchConfig || !slotID) return null

  // Check if matchConfig has gfxConfig structure (MatchConfig type)
  if ('gfxConfig' in matchConfig && matchConfig.gfxConfig?.imageSlots) {
    const imageSlot = matchConfig.gfxConfig.imageSlots.find((slot: GfxImageSlot) => slot.slotID === slotID)
    if (imageSlot) return imageSlot.url
  }

  // Fallback for simple logo URL structure
  if ('homeTeamConfig' in matchConfig) {
    if (slotID === 1 && matchConfig.homeTeamConfig?.logoURL) {
      return matchConfig.homeTeamConfig.logoURL
    }
    if (slotID === 2 && matchConfig.awayTeamConfig?.logoURL) {
      return matchConfig.awayTeamConfig.logoURL
    }
  }

  return null
}

export interface FormattedTeams {
  home: string
  homeLogo: string | null
  away: string
  awayLogo: string | null
}

export const formatIntroData = (matchConfig: MatchConfig | null): FormattedTeams | null => {
  if (!matchConfig) return null

  const data = {
    teams: {
      home: matchConfig.homeTeamConfig?.name || 'Home Team',
      homeLogo: matchConfig.homeTeamConfig?.logoURL || getMajorAsset(matchConfig, 1),
      away: matchConfig.awayTeamConfig?.name || 'Away Team',
      awayLogo: matchConfig.awayTeamConfig?.logoURL || getMajorAsset(matchConfig, 2),
    },
  }

  return data.teams
}

export interface TeamLogos {
  leftLogo: string | null
  rightLogo: string | null
}

export const getTeamLogos = (matchConfig: MatchConfig | null): TeamLogos => {
  if (!matchConfig) return { leftLogo: null, rightLogo: null }

  let leftLogo = getMajorAsset(matchConfig, 1)
  let rightLogo = getMajorAsset(matchConfig, 2)

  return { leftLogo, rightLogo }
}
